// $(document).ready(function() {
//     var video = $('#myVideo')[0];
    
//     function seamlessLoop() {
//         if (video.currentTime >= video.duration - 0.05) { // Check if close to the end
//             video.currentTime = 0; // Reset to start
//             video.play();          // Restart playback
//         }
//         requestAnimationFrame(seamlessLoop); // Continue checking
//     }

//     // Start the seamless loop check once the video is loaded and playing
//     video.addEventListener('loadeddata', function() {
//         if (video.paused) {
//             video.play();
//         }
//         requestAnimationFrame(seamlessLoop);
//     });

//     // Ensure the video starts looping correctly on ended event as well
//     video.addEventListener('ended', function() {
//         video.currentTime = 0;
//         video.play();
//     });
// });

$(document).ready(function() {
    // 初始化时激活第一个 tab
    $('.lynx-tab-links li').first().addClass('active');
    $('.tab-content .tab').first().addClass('active');

    // 点击 tab 链接时的事件处理
    $('.lynx-tab-links li').click(function(e) {
      e.preventDefault();

      var target = $(this).find('a').attr('href');

      // 移除所有 active 类
      $('.lynx-tab-links li').removeClass('active');
      $('.tab-content .tab').removeClass('active');

      // 添加 active 类到目标 tab 和内容
      $(this).addClass('active');
      $(target).addClass('active');
    });
});

var swiper = new Swiper('.lynx-swiper', {
    // speed:1000,
    slidesPerView: 3,
    spaceBetween: 50,
    prevButton:'.swiper-button-prev',
    nextButton:'.swiper-button-next',
    breakpoints: { 
        //当宽度小于等于640
        768: {
          slidesPerView: 1.8,
          spaceBetween: 16
        }
    }
});

// Your Smart Companion Throughout the Day
$(document).ready(function() {
  // 定义图片和文字内容数组
  const contents = [
      { img: "https://cdn.shopify.com/s/files/1/0536/0510/5861/files/lynx-11.png?v=1735094092" },
      { img: "https://cdn.shopify.com/s/files/1/0536/0510/5861/files/lynx-12.png?v=1735094102"},
      { img: "https://cdn.shopify.com/s/files/1/0536/0510/5861/files/lynx-13.png?v=1735094109"},
      { img: "https://cdn.shopify.com/s/files/1/0536/0510/5861/files/lynx-14.png?v=1735094118"}
  ];

  // 绑定按钮点击事件
  $('.lynx-7-btn').click(function() {
      let index = $(this).data('index');
      let content = contents[index];
      $(this).addClass("lynx-content_active");
      $(this).siblings().removeClass("lynx-content_active");  
      // 更新图片和文字
      $('#display-image').attr('src', content.img).css('opacity', 0).animate({opacity: 1}, 1000);
  });
});
$(document).on('click', '.lynx_h5_btn', function(){
  $(this).addClass("opened_title");
  $(this).siblings().removeClass("opened_title");
});

// FAQ
$(document).on('click', '.lynx_h3', function(){
  $(this).toggleClass("lynx_h3_active")
  $(this).siblings().toggleClass("faq_content_active");
});

$(document).ready(function() {
  // 为按钮绑定点击事件
  $('.lynx-openBtn').click(function() {
      $(this).toggleClass("lynx-openBtn")
      $(this).siblings().toggleClass("lynx-openBtn-content");
  });
});

// 锚点
$('.anchor_point a:first-child').click(function(){
  $('html,body').animate({ scrollTop:$('.lynx-section-6').offset().top-104}, 100);
});
$('.anchor_point a:nth-child(2)').click(function(){
  $('html,body').animate({ scrollTop:$('.lynx-section-5').offset().top-104}, 100);
});
// $('.anchor_point a:nth-child(3)').click(function(){
//   $('html,body').animate({ scrollTop:$('.lynx-section-9').offset().top-104}, 100);
// });
// $('.anchor_point_link').click(function(){
//   $('html,body').animate({ scrollTop:$('.lynx-section-8-input').offset().top - 215}, 100);
// });

$('.preBuy').click(function(){
  $('html,body').animate({ scrollTop:$('#shopify-section-lynx-featured-product').offset().top - 105}, 150);
});

$(document).ready(function(){
  $('.lynx_img').click(function(){
    $(this).addClass("mediaImgActive").siblings().removeClass("mediaImgActive");
    // 获取源图片的src属性值
    var imagePath = $(this).find("img").attr('src');
    // 将获取到的路径设置为目标图片的src属性
    $('.check_img').attr('src', imagePath);
  });

   $('.sizeBtn').click(function(){
        $(".size-guide-pop").addClass("pop_active")
  });
  $('.colsed_sizeGuide').click(function(){
        $(".size-guide-pop").removeClass("pop_active")
  });

  $('.choose-btn').click(function(){
       $(".size-list").addClass("pop_active"); 
       $(".opt-bg").css("z-index", "1");
  });

  $(document).on('click', '.size-item', function(){
      var buttonText = $(this).text();
      $(".size-list").removeClass("pop_active");
      $(".choose-btn").text(buttonText);
      $(".choose-flex-left").addClass("sizeActive");
      $(".opt-bg").css("z-index", "-1");
  });
  
  $('.opt-bg').click(function(){
     $(".size-list").removeClass("pop_active");
     $(".opt-bg").css("z-index", "-1");
  });

  $('.free-size-kit').click(function(){
      $(".choose-btn").text("Choose your size");
      $(".choose-flex-left").removeClass("sizeActive");
      $(".size-list").removeClass("pop_active");
  });
  
  $('.email').click(function(){
        $(".blog_input").addClass("activeInput");          
  });
  $('.submit').click(function(){
        $(".blog_input").removeClass("activeInput");          
  });
  
});


window.onscroll = function () {
            let flag = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
            if (flag) {
                let scrollTops = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                if (scrollTops > 1000) { 
                   $(".lynx-section-2").addClass("sticky-points");    
                }else{
                    $(".lynx-section-2").removeClass("sticky-points"); 
                }
            }
}




